<template>
    <div class="panel panel-info" v-if="ssh">
        <!-- Default panel contents -->
        <div class="panel-heading"><i class="fa fa-terminal" aria-hidden="true"></i> SSH</div>
        <div class="panel-body">
            <div class="form-group">
                <label for="inputIp" class="col-sm-1 control-label right">HOST:</label>
                <div class="col-sm-3">
                    <input type="text" v-model="ssh.host" class="form-control" id="inputIp" placeholder="###.###.###.###">
                </div>
                <label for="timeout" class="col-sm-1 control-label">TIMEOUT:</label>
                <div class="col-sm-3">
                    <input type="text" v-model.number="ssh.readyTimeout" class="form-control" id="timeout" >
                </div>
            </div>
            <div class="form-group">
                <label for="inputUsuario" class="col-sm-1 control-label">USUÁRIO:</label>
                <div class="col-sm-3">
                    <input type="text" v-model="ssh.username" class="form-control" id="inputUsuario">
                </div>
                <label for="password" class="col-sm-1 control-label">SENHA:</label>
                <div class="col-sm-3">
                    <input type="password" v-model="ssh.password" class="form-control" id="password">
                </div>
                <button type="button" class="btn btn-default" @click="change()"  v-if="user.level < 5">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        ssh: {
            default: null
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    data() {
        return {
            type: "text",
            user: null
        };
    },
    methods: {
        change() {
            // eslint-disable-next-line no-undef
            let passwordField = $("#password");
            // Get the current type of the password field will be password or text
            let passwordFieldType = passwordField.attr("type");
            // Check to see if the type is a password field
            if (passwordFieldType === "password") {
                // Change the password field to text
                passwordField.attr("type", "text");
            } else {
                // If the password field type is not a password field then set it to password
                passwordField.attr("type", "password");
            }
        }
    }
};
</script>
